import {
  CORE_LOAD_ALL_SERVICE_REQUEST,
  CORE_LOAD_ALL_SERVICE_SUCCESS,
} from '../types'
const requestState = 'request'

export default {
  services: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_SERVICE_REQUEST:
        return []
      case CORE_LOAD_ALL_SERVICE_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/services.js